import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { CountryService } from 'src/app/services/country.service';
import {MessageService} from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute } from '@angular/router';
import {FirebaseService} from 'src/app/services/firebase.service';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  countries:any=[]
  selectedCountryId
  showModal: boolean;
  content: string;
  title: string;
  displayBasic: boolean;
  terms=""
  refercode=""
  emailAddress = ""
  name = ""
  width_modal
  offer
  constructor(public auth:AuthService,public countryService:CountryService,private messageService: MessageService,public common:CommonService,public activatedRoute:ActivatedRoute, public firebase : FirebaseService) { }

  ngOnInit(): void {
    if(screen.width>960){
      this.width_modal = '40vw'
    }
    else{
      this.width_modal = '75vw'
    }
    this.activatedRoute.queryParams.subscribe(params => {
      //console.log(params)
      if(params['refer']){
        this.refercode=params['refer']
        //console.log(this.refercode)
      }

    });
    this.common.getOffers().subscribe(res => {
      this.offer = res
    }) 
    // this.getCountry()
    /* this.getTermsandConditions(name,email) */
  }

  showTerms(name,email) {
    this.displayBasic = true;
    this.getTermsandConditions(name,email)
  }

  // NORMAL REGISTERATION
  onRegisterFromSubmit(registerForm){
    this.common.showLoader()
    this.displayBasic = false;
    //console.log(registerForm)
    //console.log(registerForm.value)
    if(this.refercode){
      registerForm.value.refercode=this.refercode
    }
    // registerForm.value.country_id=parseInt(this.selectedCountryId)
    // if (registerForm.value.country_id == 39) {
    //   this.showModal = true;
    //   this.content = "This is content!!";
    //   this.title = "This is title!!";
    // }
    this.auth.register(registerForm.value)
  }

  // REGISTERATION USING FIREBASE
  // onRegisterFromSubmit(registerForm){
  //   this.firebase.signUp(registerForm)
  // }

  // getCountry(){
  //   this.common.showLoader()
  //   this.countryService.getAll().subscribe(res=>{
  //     //console.log(res)
  //     this.countries=res
  //     this.common.stopLoader()
  //   },err=>{
  //     let errorKeys = Object.keys(err.error.errors); 
  //     errorKeys.forEach(key => { 
  //       //console.log(key)
  //       let value = err.error.errors[key][0]; 
  //       this.messageService.add({severity:'error', summary:value, detail:""});
  //       //console.log(value); 
  //   }); 
  //     //console.log(err)
  //     this.common.stopLoader()
  //   })  
  // }

  isPasswordInValid(password,confirmPassword){
    return (password.value != confirmPassword.value) && password.dirty && confirmPassword.dirty
  }

  // selectCountryId(countryId, event){
  //   this.selectedCountryId=countryId
  //   //console.log(this.selectedCountryId)
  //   // if(countryId==233){
  //   //   document.getElementById("usd")[0].checked = true
  //   // }
  //   // else if(countryId==39){
  //   //   document.getElementById("cad")[0].checked = true
  //   // }
  //   // document.getElementById(event.target.id).getElementsByTagName('input')[0].checked = true
  //   // document.getElementsByClassName('active')[0].getElementsByTagName('input')[0].checked = true
  // }

  getTermsandConditions(name,email){
    this.auth.getTermsCA(name,email).subscribe((res:any)=>{
      //console.log(res)
      this.terms=res.primetrust_response.data.attributes.content
      //console.log(this.terms)
    })
  }

  showPassword(e){
    if(e.target.previousSibling.getAttribute('type') == 'password'){
      e.target.previousSibling.setAttribute('type','text')
      e.target.classList.replace('fa-eye', 'fa-eye-slash')
    }
    else{
      
      e.target.previousSibling.setAttribute('type','password')
      e.target.classList.replace('fa-eye-slash', 'fa-eye')
    }
  }

  // setCountryId(val){
  //   //console.log(val)
  //   this.firebase.country_id = val
  //   this.firebase.get_country_id = false

  //   this.firebase.proceedWithFirebaseLogin()
  // } 

  

}
